module.exports = __webpack_public_path__ + "img/people-blue-q.a81fd740.png";